import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular";

export const Container = styled.div`
  margin-bottom: 124px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;

  ${({ $isDisabled }) =>
    $isDisabled
      ? `
        opacity: 0.6;
        pointer-events: none;
        `
      : ""};

  @media screen and (min-width: 768px) {
    gap: 24px;
  }
`;

export const Title = styled.h3`
  color: #292929;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 2px;
`;

export const SearchWrapper = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const SearchInput = styled.input`
  border-radius: 8px;
  border: 1px solid #c5c5c5;
  background: #fff;
  padding: 17px 16px 17px 40px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #212121;
  display: block;
  width: 100%;

  &::placeholder {
    color: #a4a4a4;
  }
`;

export const SearchInputIcon = styled(Search)`
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  left: 16px;
  top: 50%;
  fill: #a4a4a4;
  margin-top: -8px;
`;
